export default "__VITE_ASSET__BPsHy1v5__"